// Types
import { GPS } from '../../types/global';

// Layout
import { CoordinatesType } from '../../layout/elements/Map';

export enum LiveStatus {
  on = 'on',
  off = 'off',
}

export enum ViewType {
  camera = 'camera',
  map = 'map',
}

export interface CameraFeedProps {
  className?: string;
  gpsEnabled?: boolean;
  isOpen?: boolean;
  live?: LiveStatus;
  onOpen?: (isOpen: boolean) => void;
  polygons?: CoordinatesType[] | CoordinatesType[][];
  src?: string;
  testId?: string;
  title: string;
  unitCoordinates?: GPS;
}
